<div class="accounting-periods">
  <p class="muted">
    A closed period blocks journals dated in it from being submitted. Drafts can still be saved and are submitted once the period is reopened.
    @if (canManage) { Click a period to close or reopen it. } @else { Only period owners can close or reopen periods. }
  </p>

  @if (Loading) {
  <p class="muted" role="status">Loading periods…</p>
  }

  <rms-table [data]="Rows"
             [columns]="Columns"
             [clickableRow]="true"
             (onRowClick)="open($event.row)"
             tableId="ledger-periods">
  </rms-table>
</div>
